import { useState, useEffect } from "react";
import ReactPaginate from "react-paginate";
import { useNavigate } from "react-router-dom";
import clienteAxios from "../../helpers/axios.helper";
import Swal from "sweetalert2";  // Importamos SweetAlert

function TablaMarcas() {
  const [marcas, setMarcas] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 15;
  const navigate = useNavigate();

  // Cargar marcas desde la base de datos
  useEffect(() => {
    const fetchMarcas = async () => {
      try {
        const response = await clienteAxios.get("/marcas");
        setMarcas(response.data);
      } catch (error) {
        console.error("Error al cargar las marcas:", error);
      }
    };

    fetchMarcas();
  }, []);

  const offset = currentPage * itemsPerPage;
  const currentItems = marcas.slice(offset, offset + itemsPerPage);
  const pageCount = Math.ceil(marcas.length / itemsPerPage);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  // Manejar eliminación de marcas con SweetAlert
  const eliminarMarca = async (id) => {
    // Usamos SweetAlert para confirmar la eliminación
    const result = await Swal.fire({
      title: "¿Estás seguro?",
      text: "¡Esta acción no se puede deshacer!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    });

    if (result.isConfirmed) {
      try {
        await clienteAxios.delete(`marcas/${id}`);
        Swal.fire("Eliminado!", "La marca ha sido eliminada.", "success");
        setMarcas(marcas.filter((marca) => marca.id !== id));
      } catch (error) {
        console.error("Error al eliminar la marca:", error);
        Swal.fire("Error", "No se pudo eliminar la marca.", "error");
      }
    }
  };

  const handleEditar = (marca) => {
    navigate("/formulario-marca", { state: { marca, modoEdicion: true } });
  };

  return (
    <div className="bg-white p-4 rounded-lg border-2 border-GrisOscuro">
      {/* Botón para agregar */}
      <div className="flex justify-end mb-4">
        <button
          className="py-2 px-4 bg-Verde text-Blanco font-semibold rounded hover:bg-green-600"
          onClick={() => navigate("/formulario-marca")}
        >
          Agregar Marca
        </button>
      </div>

      {/* Tabla */}
      <table className="min-w-full bg-white border">
        <thead>
          <tr>
            <th className="text-start py-2 px-4 border-b">Nombre</th>
            <th className="text-start py-2 px-4 border-b">Acciones</th>
          </tr>
        </thead>
        <tbody>
          {currentItems.map((marca) => (
            <tr key={marca.id}>
              <td className="py-2 px-4 border-b">{marca.nombre}</td>
              <td className="py-2 px-4 border-b">
                <div className="flex space-x-2">
                  <button
                    className="px-3 py-1 bg-Amarillo text-Blanco rounded border hover:bg-Blanco hover:text-Negro hover:border-Amarillo"
                    onClick={() => handleEditar(marca)}
                  >
                    Editar
                  </button>
                  <button
                    className="px-3 py-1 bg-Rojo text-Blanco rounded border hover:bg-Blanco hover:text-Negro hover:border-Rojo"
                    onClick={() => eliminarMarca(marca.id)}
                  >
                    Eliminar
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Paginación */}
      <div className="flex w-full flex-row h-20 justify-center items-end">
        <ReactPaginate
          breakLabel="..."
          nextLabel=">"
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel="<"
          renderOnZeroPageCount={null}
          containerClassName="flex justify-center items-center"
          pageClassName="p-1 px-3 text-Negro bg-GrisClaro"
          activeClassName="bg-GrisOscuro text-Blanco"
          previousClassName="px-2 py-1 text-Rojo font-bold text-xl"
          nextClassName="px-2 py-1 text-Rojo font-bold text-xl"
          breakClassName="px-2 py-1 text-Rojo"
        />
      </div>
    </div>
  );
}

export default TablaMarcas;
